export const ProfileDropdownProps = {
    default: {
        navigation: [
            {
                href: "",
                name: "Logout",
            },
        ],
    },
};
